import { Injectable } from '@angular/core'
import { DateTime } from 'luxon'
import { VerifiedInformation } from 'se-resource-types/dist/lib/UserService'

@Injectable({
  providedIn: 'root',
})
export class VerifiedInfoService {
  constructor() {
    // noop
  }

  public getFormattedDate(dateStr: string): string {
    return DateTime.fromISO(dateStr).toFormat('MMM d, yyyy')
  }

  public getFormattedGender(gender: string): string {
    return gender[0].toUpperCase() + gender.substring(1).toLowerCase()
  }

  public getFormattedName(verifiedInfo: VerifiedInformation, includeMiddleName?: boolean): string {
    const parts = [verifiedInfo.first_name]

    if (includeMiddleName && verifiedInfo.middle_name) {
      parts.push(verifiedInfo.middle_name)
    }

    if (verifiedInfo.suffix) {
      parts.push(verifiedInfo.last_name + ', ' + verifiedInfo.suffix)
    }
    else {
      parts.push(verifiedInfo.last_name)
    }

    return parts.join(' ')
  }
}
